import { createContext } from 'react';

const UserContext = createContext(null);
UserContext.displayName = 'UserContext';

export default UserContext;
